<!-- 模块容器组件 -->
<template>
  <div class="module-container" :class="containerClass">
    <!-- 模块头部 -->
    <div
      v-if="showHeader"
      class="module-header"
      :class="{ 'no-icon': !showIcon }"
      :style="{
        paddingTop: headerPaddingTop
          ? typeof headerPaddingTop === 'number'
            ? headerPaddingTop + 'px'
            : headerPaddingTop
          : undefined
      }"
    >
      <div class="header-title-wrapper">
        <h3>
          <span v-if="showIcon" class="module-header-icon"></span>
          <slot name="title">
            <span
              class="module-header-title"
              v-if="title"
              :title="title"
              :class="{ 'title-no-icon': !showIcon }"
              >{{ title }}</span
            >
          </slot>
        </h3>
        <div v-if="description" class="module-header-description">
          {{ description }}
        </div>
      </div>
      <!-- 头部筛选区域插槽 -->
      <div v-if="$slots.filters" class="header-filters">
        <slot name="filters"></slot>
      </div>
    </div>
    <!-- 模块内容区域插槽 -->
    <div
      class="module-body"
      :class="[
        bodyClass,
        {
          'has-padding': padding,
          'is-loading': loading,
          'padding-no-top': padding && !showIcon
        }
      ]"
      :style="bodyStyle"
    >
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-wrapper">
        <i class="el-icon-loading"></i>
        <span v-if="loadingText" class="loading-text">{{ loadingText }}</span>
      </div>
      <!-- 默认插槽：主要内容 -->
      <slot v-if="!loading || showContentWhenLoading"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModuleContainer',
  props: {
    // 标题（如果使用 prop，插槽为空时显示）
    title: {
      type: String,
      default: ''
    },
    // 描述（如果使用 prop，插槽为空时显示）
    description: {
      type: String,
      default: ''
    },
    // 是否显示加载状态
    loading: {
      type: Boolean,
      default: false
    },
    // 加载提示文字
    loadingText: {
      type: String,
      default: ''
    },
    // 加载时是否显示内容（默认隐藏）
    showContentWhenLoading: {
      type: Boolean,
      default: false
    },
    // 是否显示头部
    showHeader: {
      type: Boolean,
      default: true
    },
    // 是否显示头部图标
    showIcon: {
      type: Boolean,
      default: true
    },
    // 内容区域是否使用内边距
    padding: {
      type: Boolean,
      default: true
    },
    // 自定义容器类名
    containerClass: {
      type: [String, Object, Array],
      default: ''
    },
    // 自定义内容区域类名
    bodyClass: {
      type: [String, Object, Array],
      default: ''
    },
    // 自定义内容区域样式
    bodyStyle: {
      type: [String, Object],
      default: () => ({})
    },
    // 头部内边距（顶部）
    headerPaddingTop: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.module-container {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;
  flex-shrink: 0;
  min-width: 0; // 防止 flex 子元素溢出

  .module-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 14px 14px 0;
    box-shadow: 0px 1px 0px 0px #eeeeee;
    flex-shrink: 0;
    background: #ffffff;

    .header-title-wrapper {
      display: flex;
      flex-direction: column;
      // flex: 1;
      min-width: 0;
    }

    // 无图标时的样式
    &.no-icon {
      box-shadow: none;
    }

    .module-header-icon {
      width: 4px;
      height: 18px;
      background: #1f3696;
      border-radius: 0px 4px 4px 0px;
      display: inline-block;
      margin-right: 20px;
      flex-shrink: 0;
    }

    .module-header-description {
      font-size: 14px;
      color: #909399;
      margin-top: 8px;
      margin-left: 24px;
    }

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      display: flex;
      align-items: center;
      flex: 1;
      // 无图标时标题的左边距
      .title-no-icon {
        margin-left: 24px;
      }
      .module-header-title {
        display: -webkit-box; /* 使用 flexbox */
        -webkit-box-orient: vertical; /* 设置为垂直方向 */
        -webkit-line-clamp: 2; /* 限制为2行 */
        overflow: hidden; /* 超出内容隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
    }

    .header-filters {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      // flex-shrink: 0;
      flex: 1;
      margin-left: 10px;
    }
  }

  .module-body {
    flex: 1;
    position: relative;
    overflow: auto;

    // 内边距
    &.has-padding {
      padding: 24px;
    }

    // 无图标时，顶部内边距为0
    &.padding-no-top {
      padding-top: 0;
    }

    // 信息卡片网格样式（使用深度选择器穿透 scoped）
    ::v-deep .info-cards-grid {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;

      // 确保 info-card 保持固定宽度
      .info-card {
        flex: 0 0 auto;
        width: 300px;
      }
    }

    // 加载状态
    .loading-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      z-index: 10;

      .el-icon-loading {
        font-size: 24px;
        color: #409eff;
        animation: rotating 2s linear infinite;
      }

      .loading-text {
        font-size: 14px;
        color: #909399;
      }
    }
  }
}

// 加载动画
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

// 响应式设计
// @media (max-width: 768px) {
//   .module-container {
//     .module-header {
//       flex-direction: column;
//       align-items: flex-start;
//       gap: 12px;
//       padding: 12px 16px 12px 0;

//       .header-filters {
//         width: 100%;
//         justify-content: flex-end;
//       }
//     }

//     .module-body.has-padding {
//       padding: 16px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//     }
//   }
// }
</style>
